module.exports = __webpack_public_path__ + "static/media/icono_mago.e6f609ee.svg";